import { createReducer, on } from "@ngrx/store";
import { UserContactsState } from "@State/app.state";
import * as ContactsActions from "@Actions/contacts.actions";

const userContactsInitialState: UserContactsState = {
  contacts: [],
  loadError: false,
  doneLoading: false
}

export const userContactsReducer = createReducer(
  userContactsInitialState,
  on(ContactsActions.setContacts, (state, { contacts }) => {
    return { ...state, contacts };
  }),
  on(ContactsActions.contactsLoadError, (state) => {
    return { ...state, loadError: true };
  }),
  on(ContactsActions.contactsDoneLoading, (state) => {
    return { ...state, doneLoading: true };
  }),
  on(ContactsActions.clearContactsState, () => {
    return userContactsInitialState;
  })
)
